import React from "react";

export const PersonnelRoutesContext = React.createContext();
